import { RequestsGetDataStore } from './../../requests-get-data-service/requests-get-data.store';
import { RequestPanelService } from './request-panel.service';
import { ForwardLinkComponent } from './../../../@shared/dialogs/forward-link/forward-link.component';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AuthenticationService, CredentialsService } from '@app/login';
import { UserAttributionsEnum } from '@app/@core/constants/user-credentials.constants';
import { RequestPanelStore } from './request-panel.store';
import { DocumentIdNumRequestDTO, Operation, OperationsQueryDto } from '@app/requests/model/requests-model';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { MatPaginator } from '@angular/material/paginator';
import { DatePipe } from '@angular/common';
import { ExcelService } from '@app/@shared/services/print/excel.service';
import { TranslateService } from '@ngx-translate/core';
import jsPDF from 'jspdf';
import { UserType } from '@app/@core/constants/user-credentials.constants';
import autoTable from 'jspdf-autotable';
import {
  ABONADAS_PENDIENTES_DE_VALIDACION,
  ANULADAS,
  APROBADAS,
  CAPTACION_CANAL,
  CONDICIONADA_PENDIENTE_DE_FORMALIZACION,
  DENEGADAS,
  EN_ESTUDIO,
  FINANCIAL_PRODUCT_AUTO,
  FINANCIAL_PRODUCT_C,
  FIRMADAS,
  FORMALIZADAS_ABONADAS_VALIDADAS,
  HostCodes,
  OPERATIVE_EIC,
  OPERATIVE_ESC,
  PENDIENTES_DE_DATOS,
  PENDIENTES_PAGO_POR_INCIDENCIAS,
  REQUEST_APPROVED,
  REQUEST_CONDTIONATED_VALIDATION,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_VIEW,
  REQUEST_PENDING_PAYMENT_INCIDENT,
  REQUEST_STUDYING,
  VALUE_TRUE,
} from '@app/@core/constants/requests.constants';
import { DigitalSignatureServiceStore } from '@app/requests/logalty-digital-signature/digital-signature-service/digital-signature-service.store';
import { Router } from '@angular/router';
import { IneSignatureStore } from '@app/requests/ine-signature/services/ine-signature.store';
import { IneDTOcall } from '@app/requests/model/ine-model';
import { PanelStore } from '@app/requests/panel/panel.store';
import { PrintContractDTO } from '@app/requests/model/requests-model';
import { PrintStore } from '@app/@shared';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { DetectDeviceService } from '@shared/services/utils/detect-device.service';
import {
  URL_REQUESTS_PENDING_VIDEOSELFING,
  URL_REQUESTS_SHOW_EDIT,
  URL_REQUESTS_UPDATE_DOCUMENTATION,
} from '@app/@core/constants/routes.constants';
import FileSaver from 'file-saver';
import { ActivityStore } from '@app/activity/activity-services/activity.store';
import moment from 'moment';
import { UpdateDocumentationStore } from '@app/requests/update-documentation/update-documentation.store';
import { RequestsGetDataApi } from '@app/requests/requests-get-data-service/requests-get-data-api.service';
import { COMMERCIAL_EXTERNAL, COMMERCIAL_INTERNAL, OFFICE_DIRECTOR } from '@app/@core/constants/users.constants';

@Component({
  selector: 'scf-request-panel',
  templateUrl: './request-panel.component.html',
  styleUrls: ['./request-panel.component.scss'],
})
export class RequestPanelComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isMainPanel: boolean;
  @Input() isFilter: boolean = false;
  @Input() isPendingRequests: boolean = false;
  @Input() state: CommonDataDTO;
  @Input() searchOperations: OperationsQueryDto;
  @Input() isSpecificSearch: boolean = false;
  @Input() specificSearchOperations: Operation[];

  @Output() changeContinueView = new EventEmitter<any>();
  @Output() allData = new EventEmitter<any>();
  @Output() viewRequest = new EventEmitter<any>();
  @Output() finishedLoading = new EventEmitter<boolean>();
  @Output() keepSearch = new EventEmitter<any>();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  private paginationKeys: string[] = [''];
  private currentDate: Date = new Date();
  private threeMonthsAgo: Date = new Date();

  selectedRow: number;
  FINANCIAL_PRODUCT_AUTO: string = FINANCIAL_PRODUCT_AUTO;
  FINANCIAL_PRODUCT_C: string = FINANCIAL_PRODUCT_C;

  //Order of the headers' labels displayed in the table, using id
  displayedColumns: string[] = [
    'status',
    'numberRequest',
    'canal',
    'firstUpdate',
    'lastUpdate',
    'clientName',
    'seller',
    'financed',
    'signature',
    'action',
    'more',
  ];

  private head = [
    'request.numberRequest',
    'request.captacionCanal',
    'request.firstUpdate',
    'request.lastUpdate',
    'request.nameClient',
    'request.seller',
    'request.prod',
    'request.pro',
    'request.financed',
  ];

  title: string;

  CAPTACION_CANAL = CAPTACION_CANAL;
  public colorStatus: string;

  //Property esthetics purpose
  public classAttribute: string;

  //Properties for buttons
  public hasNextKey: boolean = false;
  public hasPreviousKey: boolean = false;

  //Operations
  public numPage: number = 0;
  public totalNumPagesAll: number = 0;

  private requestSubscription: Subscription;
  private userInfo: any;

  dataSource = new MatTableDataSource<Operation>();

  constructor(
    private authenticationService: AuthenticationService,
    public credentials: CredentialsService,
    private requestPanelStore: RequestPanelStore,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private excelService: ExcelService,
    private router: Router,
    private digitalSignatureServiceStore: DigitalSignatureServiceStore,
    private ineSignaturaStore: IneSignatureStore,
    private panelStore: PanelStore,
    private printStore: PrintStore,
    public dialog: MatDialog,
    private detectDeviceService: DetectDeviceService,
    private activityStore: ActivityStore,
    private requestService: RequestPanelService,
    private translateService: TranslateService,
    private getDataApi: RequestsGetDataApi,
    private getDataStore: RequestsGetDataStore,
    private updateDocumentationStore: UpdateDocumentationStore
  ) {
    this.userInfo = credentials.credentials;
  }

  ngOnDestroy(): void {
    this.requestSubscription?.unsubscribe();
    this.dataSource.data = [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.state?.isFirstChange()) {
      if (!!changes.state) {
        this.title = changes.state?.currentValue?.value;
      }
    }
    if (!changes.searchOperations?.isFirstChange()) {
      if (this.state?.id === this.searchOperations?.state) {
        this.loadOperationsOnSearch(this.searchOperations);
      }
    }
    if (!changes.isMainPanel?.isFirstChange() && changes.isMainPanel) {
      if (changes.isMainPanel?.currentValue == true) {
        this.hasPreviousKey = false;
        this.loadOperationsMainPanel();
      }
    }
    if (this.specificSearchOperations && this.specificSearchOperations.length > 0) {
      //se recogen las operaciones que manda el operation-search
      this.dataSource.data = this.specificSearchOperations;
    }
  }

  ngOnInit(): void {
    this.dataSource.data = [];
    let url = this.router.url.split(';'); //we need to remove the params
    localStorage.setItem('pageOpenSignature', JSON.stringify({ url: url[0] }));
    //sólo se hace la búsqueda en el oninit si no es una búsqueda específica por operación o dni
    if (!this.isSpecificSearch) {
      this.threeMonthsAgo.setMonth(this.threeMonthsAgo.getMonth() - 3);

      this.loadOperationsMainPanel();
      if (!this.isMainPanel) {
        this.loadOperationsOnSearch(this.searchOperations);
      }
    }
    if (this.state) {
      this.title = this.state.value;
    }
    this.translateService.onLangChange.subscribe((event) => {
      if (this.state) {
        this.title = this.state.value;
      }
    });
  }

  loadOperationsMainPanel(): void {
    this.dataSource.data = [];
    //TODO: change cases for ids
    //TODO: Change manually set colors and use theme
    switch (this.state.id) {
      case PENDIENTES_DE_DATOS:
        this.classAttribute = 'panel-request__card-header-icon--pending';
        if (this.isMainPanel) {
          this.requestSubscription = this.requestPanelStore.pendingRequestsList$.subscribe(
            (data) => {
              this.dataSource.data = data.operations;
              if (data.nextKey === '') {
                this.hasNextKey = false;
              } else {
                this.paginationKeys.push(data.nextKey);
                this.hasNextKey = true;
              }
              this.allData.emit({ state: this.state.value, data: this.dataSource });
              this.finishedLoading.emit(true);
            },
            (error) => {
              console.error(error);
            }
          );
        }
        break;
      case APROBADAS:
        this.classAttribute = 'panel-request__card-header-icon--approved';
        if (this.isMainPanel) {
          this.requestSubscription = this.requestPanelStore.approvedRequestsList$.subscribe(
            (data) => {
              this.dataSource.data = data.operations;
              if (data.nextKey === '') {
                this.hasNextKey = false;
              } else {
                this.paginationKeys.push(data.nextKey);
                this.hasNextKey = true;
              }
              this.allData.emit({ state: this.state.value, data: this.dataSource });
              this.finishedLoading.emit(true);
            },
            (error) => {
              console.error(error);
            }
          );
        }
        break;
      case FIRMADAS:
        this.classAttribute = 'panel-request__card-header-icon--signed';
        if (this.isMainPanel) {
          this.requestSubscription = this.requestPanelStore.signedRequestsList$.subscribe(
            (data) => {
              this.dataSource.data = data.operations;
              if (data.nextKey === '') {
                this.hasNextKey = false;
              } else {
                this.paginationKeys.push(data.nextKey);
                this.hasNextKey = true;
              }
              this.allData.emit({ state: this.state.value, data: this.dataSource });
              this.finishedLoading.emit(true);
            },
            (error) => {
              console.error(error);
            }
          );
        }
        break;
      case EN_ESTUDIO:
        this.classAttribute = 'panel-request__card-header-icon--study';
        if (this.isMainPanel) {
          this.requestSubscription = this.requestPanelStore.underStudyRequestsList$.subscribe(
            (data) => {
              this.dataSource.data = data.operations;

              if (data.nextKey === '') {
                this.hasNextKey = false;
              } else {
                this.paginationKeys.push(data.nextKey);
                this.hasNextKey = true;
              }

              this.allData.emit({ state: this.state.value, data: this.dataSource });
              this.finishedLoading.emit(true);
            },
            (error) => {
              console.error(error);
            }
          );
        }
        break;
      case DENEGADAS:
        this.classAttribute = 'panel-request__card-header-icon--denied';
        if (this.isMainPanel) {
          this.requestSubscription = this.requestPanelStore.deniedRequestsList$.subscribe(
            (data) => {
              this.dataSource.data = data.operations;

              if (data.nextKey === '') {
                this.hasNextKey = false;
              } else {
                this.paginationKeys.push(data.nextKey);
                this.hasNextKey = true;
              }

              this.allData.emit({ state: this.state.value, data: this.dataSource });
              this.finishedLoading.emit(true);
            },
            (error) => {
              console.error(error);
            }
          );
        }
        break;
      case ABONADAS_PENDIENTES_DE_VALIDACION:
        this.classAttribute = 'panel-request__card-header-icon--pending';
        if (this.isMainPanel) {
          this.requestSubscription = this.requestPanelStore.paidPendingValidationRequestsList$.subscribe(
            (data) => {
              this.dataSource.data = data.operations;

              if (data.nextKey === '') {
                this.hasNextKey = false;
              } else {
                this.paginationKeys.push(data.nextKey);
                this.hasNextKey = true;
              }

              this.allData.emit({ state: this.state.value, data: this.dataSource });
              this.finishedLoading.emit(true);
            },
            (error) => {
              console.error(error);
            }
          );
        }
        break;
      case FORMALIZADAS_ABONADAS_VALIDADAS:
        this.classAttribute = 'panel-request__card-header-icon--formalized';
        if (this.isMainPanel) {
          this.requestSubscription = this.requestPanelStore.formalizedPaidAndValidatedRequestsList$.subscribe(
            (data) => {
              this.dataSource.data = data.operations;

              if (data.nextKey === '') {
                this.hasNextKey = false;
              } else {
                this.paginationKeys.push(data.nextKey);
                this.hasNextKey = true;
              }

              this.allData.emit({ state: this.state.value, data: this.dataSource });
              this.finishedLoading.emit(true);
            },
            (error) => {
              console.error(error);
            }
          );
        }
        break;
      case ANULADAS:
        this.classAttribute = 'panel-request__card-header-icon--canceled';
        if (this.isMainPanel) {
          this.requestSubscription = this.requestPanelStore.cancelledRequestsList$.subscribe(
            (data) => {
              this.dataSource.data = data.operations;

              if (data.nextKey === '') {
                this.hasNextKey = false;
              } else {
                this.paginationKeys.push(data.nextKey);
                this.hasNextKey = true;
              }

              this.allData.emit({ state: this.state.value, data: this.dataSource });
              this.finishedLoading.emit(true);
            },
            (error) => {
              console.error(error);
            }
          );
        }
        break;
      case PENDIENTES_PAGO_POR_INCIDENCIAS:
        this.classAttribute = 'panel-request__card-header-icon--pending-incidents';
        if (this.isMainPanel) {
          this.requestSubscription = this.requestPanelStore.pendingPaymentDueToIncidencesRequestsList$.subscribe(
            (data) => {
              this.dataSource.data = data.operations;

              if (data.nextKey === '') {
                this.hasNextKey = false;
              } else {
                this.paginationKeys.push(data.nextKey);
                this.hasNextKey = true;
              }

              this.allData.emit({ state: this.state.value, data: this.dataSource });
              this.finishedLoading.emit(true);
            },
            (error) => {
              console.error(error);
            }
          );
        }
        break;
      case CONDICIONADA_PENDIENTE_DE_FORMALIZACION:
        this.classAttribute = 'panel-request__card-header-icon--conditioned-pending';
        if (this.isMainPanel) {
          this.requestSubscription = this.requestPanelStore.conditionedPendingFormalizationList$.subscribe(
            (data) => {
              this.dataSource.data = data.operations;

              if (data.nextKey === '') {
                this.hasNextKey = false;
              } else {
                this.paginationKeys.push(data.nextKey);
                this.hasNextKey = true;
              }

              this.allData.emit({ state: this.state.value, data: this.dataSource });
              this.finishedLoading.emit(true);
            },
            (error) => {
              console.error(error);
            }
          );
        }
        break;
      default:
        console.error('No se ha encontrado estado de solicitudes');
    }
  }

  loadOperationsOnSearch(searchParameters: OperationsQueryDto): void {
    if (searchParameters) {
      this.requestSubscription?.unsubscribe();
      this.dataSource.data = [];
      this.changeContinueView.emit(this.state.id);
      this.requestPanelStore
        .loadAllOperationsFind(
          this.state.id,
          this.datePipe.transform(searchParameters.initialDate, 'yyyy'),
          this.datePipe.transform(searchParameters.initialDate, 'MM'),
          this.datePipe.transform(searchParameters.finalDate, 'yyyy'),
          this.datePipe.transform(searchParameters.finalDate, 'MM')
        )
        .then(
          (data) => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.data = data.detailsOperations.operations;
            this.paginationKeys = ['', data.paginationKeys[0]];
            this.numPage = parseInt(data.numPage);
            this.hasPreviousKey = this.numPage > 0;

            if (data.detailsOperations.nextKey === '') {
              this.hasNextKey = false;
            } else {
              this.hasNextKey = true;
            }
          },
          (error) => console.error(error)
        )
        .finally(() => {
          this.finishedLoading.emit(true);
        });
    }
  }

  loadMoreOperations(paginationType: string) {
    this.requestSubscription?.unsubscribe();
    this.requestPanelStore
      .loadAllOperationsPagination(
        this.state.id,
        this.paginationKeys,
        this.numPage.toString(),
        paginationType,
        this.isFilter ? this.datePipe.transform(this.searchOperations.initialDate, 'yyyy') : '',
        this.isFilter ? this.datePipe.transform(this.searchOperations.initialDate, 'MM') : '',
        this.isFilter ? this.datePipe.transform(this.searchOperations.finalDate, 'yyyy') : '',
        this.isFilter ? this.datePipe.transform(this.searchOperations.finalDate, 'MM') : ''
      )
      .then(
        (data) => {
          this.dataSource.data = data.detailsOperations.operations;
          this.numPage = parseInt(data.numPage);
          this.hasPreviousKey = this.numPage > 0;

          if (data.detailsOperations.nextKey === '') {
            this.hasNextKey = false;
          } else {
            this.paginationKeys.push(data.detailsOperations.nextKey);
            this.hasNextKey = true;
          }
        },
        (error) => console.error(error)
      );
  }

  /* CLICK EVENTS */
  handleChipClick(status: any, element: any): void {
    switch (status.class) {
      case 'completeData':
        this.onClickViewRequest(element);
        break;
      case 'documentationPending':
        this.onClickAttach(element);
        break;
      case 'addParticipant':
        this.onClickViewRequest(element, true);
        break;
      case 'review':
      case 'validatedSignatureIne':
        this.onClickWarn(element);
        break;
      default:
        break;
    }
  }

  onClickViewAllRequests(event?: Event): void {
    event.stopPropagation();
    this.requestSubscription?.unsubscribe();
    this.dataSource.data = [];

    this.changeContinueView.emit(this.state.id);

    this.requestPanelStore.loadAllOperations(this.state.id, 'N').then(
      (data) => {
        this.dataSource.paginator = this.paginator;
        this.dataSource.data = data.detailsOperations.operations;
        this.paginationKeys = ['', data.paginationKeys[0]];

        this.numPage = parseInt(data.numPage);
        this.hasPreviousKey = this.numPage > 0;

        if (data.detailsOperations.nextKey === '') {
          this.hasNextKey = false;
        } else {
          this.hasNextKey = true;
        }
      },
      (error) => console.error(error)
    );
  }

  onClickViewRequest(element: Operation, addParticipantTab?: boolean): void {
    // TODO: REVISAR
    let mode;
    if (this.isOperativeEIC(element)) {
      mode = REQUEST_MODE_VIEW;
    } else {
      mode = element.editable || element.status === '00' ? REQUEST_MODE_EDIT : REQUEST_MODE_VIEW;
    }
    if (element.hostStatus === REQUEST_CONDTIONATED_VALIDATION) {
      element.status = REQUEST_CONDTIONATED_VALIDATION;
    }

    //ponemos en el store la operacion
    this.panelStore.setOperationToShow(element);

    if (this.isEnabledINE(element)) {
      localStorage.setItem('requiredNumRackCarRegistration', JSON.stringify(false));
      console.log('setRequiredNumRackCarRegistration false');
    } else if (this.isEnabledVideoselfing(element)) {
      localStorage.setItem('requiredNumRackCarRegistration', JSON.stringify(false));
      console.log('setRequiredNumRackCarRegistration false');
    } else if (this.isEnabledDigitalSignature(element) || this.isEnabledForwarding(element)) {
      localStorage.setItem('requiredNumRackCarRegistration', JSON.stringify(true));
      console.log('setRequiredNumRackCarRegistration true');
    } else {
      localStorage.setItem('requiredNumRackCarRegistration', JSON.stringify(false));
      console.log('setRequiredNumRackCarRegistration false error');
    }

    this.router.navigate([URL_REQUESTS_SHOW_EDIT, mode], {
      replaceUrl: false,
    });

    let url = this.router.url.split(';'); //we need to remove the params
    localStorage.setItem('previusRoute', JSON.stringify({ url: url[0] }));

    if (addParticipantTab) {
      localStorage.setItem('addParticipantTab', 'true');
    }

    this.viewRequest.emit(element.numOperation);
  }

  onClickAttach(element: Operation): void {
    this.keepSearch.emit(element);

    let document = this.updateDocumentationStore.getDocumentIdNumRequestHistoryByNumRequest(element.numOperation);
    if (!document) {
      const documentIdNumRequestDTO: DocumentIdNumRequestDTO = {
        documentId: element.legalIdentity,
        numOperation: element.numOperation,
        commercialProduct: element.commercialProduct,
      };
      this.updateDocumentationStore.addDocumentIdNumRequestHistory(documentIdNumRequestDTO);
    }

    let url = this.router.url.split(';'); //we need to remove the params
    localStorage.setItem('pageOpenSignature', JSON.stringify({ url: url[0] }));

    this.router.navigate([URL_REQUESTS_UPDATE_DOCUMENTATION, element.numOperation], {
      replaceUrl: false,
      state: {
        commercialProduct: element.commercialProduct,
      },
    });
  }

  onClickSign(element: Operation): void {
    this.keepSearch.emit(element);

    let url = this.router.url.split(';'); //we need to remove the params
    localStorage.setItem('pageOpenSignature', JSON.stringify({ url: url[0] }));

    console.log('Method: onClickSign', url);

    if (element.hasNotaryAlert) {
      const dialogConfig: MatDialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        title: this.translateService.instant('dialog.response.notaryAlert.title'),
        text: this.translateService.instant('dialog.response.notaryAlert.text'),
        icon: 'icon-ic_warning',
        buttonCancel: false,
      };
      this.dialog.open(ResponseDialogComponent, dialogConfig);
    } else {
      this.digitalSignatureServiceStore.manageSignature(
        element,
        false,
        this.detectDeviceService.isAccessByDevice(),
        false
      );
    }
  }

  onClickForwardAcquiescence(element: Operation): void {
    console.log('Method: onClickForwardAcquiescence');
    this.digitalSignatureServiceStore.manageAsyncSignature(element);
  }

  onClickPrint(element: Operation): void {
    console.log('Method: onClickPrint, element: ', element);

    let url = this.router.url.split(';'); //we need to remove the params
    localStorage.setItem('pageOpenSignature', JSON.stringify({ url: url[0] }));

    //this.digitalSignatureServiceStore.manageSignature(element, true, false);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';

    if (element.hasNotaryAlertForPrint && !this.hasPrintingNotary()) {
      dialogConfig.data = {
        text: this.translate.instant('signature.dialog.notary.notallowed'),
        icon: 'icon-ic_warning',
        buttonCancel: false,
        noRedirect: true,
      };
      const dialogNotary = this.dialog.open(ResponseDialogComponent, dialogConfig);
      dialogNotary.afterClosed().subscribe(() => {
        if (this.hasPrintingNotary()) {
          this.managePrint(element, dialogConfig);
        }
      });
    } else {
      this.managePrint(element, dialogConfig);
    }
  }

  onClickWarn(element: Operation) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';
    if (
      element.hostStatus === HostCodes.IN_COMPLIANCE_STUDY ||
      element.hostStatus === HostCodes.PENDING_STUDY ||
      element.hostStatus === HostCodes.OPERATION_ASSIGNED_BY_RISKS ||
      element.hostStatus === HostCodes.MANUAL_DOUT
    ) {
      dialogConfig.data = {
        title: this.translate.instant('dialog.title.review'),
        text: this.translate.instant('dialog.body.review'),
        icon: 'icon-ic_inbox_message',
        hasButtonAccept: false,
        buttonClose: true,
      };
      this.dialog.open(ResponseDialogComponent, dialogConfig);
    } else if (
      element.hostStatus === HostCodes.DOC_OK_PENDING_SIGNATURE ||
      element.hostStatus === HostCodes.PENDING_GOOD_DELIVERY
    ) {
      dialogConfig.data = {
        title: this.translate.instant('dialog.title.docReview'),
        text: this.translate.instant('dialog.body.docReview'),
        icon: 'icon-ic_inbox_message',
        hasButtonAccept: false,
        buttonClose: true,
      };
      this.dialog.open(ResponseDialogComponent, dialogConfig);
    }
  }

  private managePrint(operation: any, dialogConfig: MatDialogConfig): void {
    console.log('manage print, ', operation);

    if (operation.printCode == '3') {
      //show dialog check date
      dialogConfig.data = {
        title: this.translate.instant('dialog.check.date.title'),
        text: this.translate.instant('dialog.check.date.text'),
        icon: 'icon-ic_warning',
        buttonCancel: false,
      };

      const dialogCheckDate = this.dialog.open(ResponseDialogComponent, dialogConfig);
    } else {
      //show dialog of Binding offer
      dialogConfig.data = {
        title: this.translate.instant('dialog.bidingoffer.title'),
        text: this.translate.instant('dialog.bidingoffer.text'),
        icon: 'icon-ic_warning',
        buttonCancel: true,
      };

      const dialogBindingOffer = this.dialog.open(ResponseDialogComponent, dialogConfig);

      dialogBindingOffer.afterClosed().subscribe((accept: boolean) => {
        if (operation.hasNotaryAlertForPrint) {
          dialogConfig.data = {
            text: this.translate.instant('signature.dialog.notary.info'),
            icon: 'icon-ic_warning',
            buttonCancel: true,
            noRedirect: true,
          };
          const dialogNotary = this.dialog.open(ResponseDialogComponent, dialogConfig);
          dialogNotary.afterClosed().subscribe((accepted) => {
            if (accepted && this.hasPrintingNotary()) {
              this.printing(operation, accept, dialogConfig);
            }
          });
        } else {
          this.printing(operation, accept, dialogConfig);
        }
      });
    }
  }

  private printing(operation: any, accept: boolean, dialogConfig: MatDialogConfig) {
    let printContract: PrintContractDTO = {
      bindOffer: '',
      coBrand: operation.comarca,
      codeOperative: operation.operative,
      codeProduct: operation.commercialProduct,
      dateEntry: operation.dateEntry,
      isIne: operation.ine ? '' : 'S',
      language: operation.language,
      notary: '',
      numOperation: operation.numOperation,
      versionContract: operation.versionContract,
      versionPolicy: '',
    };

    if (accept !== undefined) {
      if (accept) {
        printContract.bindOffer = 'S';
      } else {
        printContract.bindOffer = 'N';
      }

      //Status is 90 -> print
      if (operation.status == FORMALIZADAS_ABONADAS_VALIDADAS) {
        this.printStore.printContract(printContract).then(
          (data) => {
            if (data) {
              console.log(operation);
              this.printStore.openPDFOnSuccess(
                data,
                operation.numOperation,
                operation.language,
                '',
                printContract,
                operation.legalIdentity
              );
            }
          },
          (error) => {
            console.log('error print: ', error);

            dialogConfig.data = { text: error, icon: 'icon-ic_circle_cross' };
            this.dialog.open(ResponseDialogComponent, dialogConfig);
          }
        );
      } else {
        //manage consents
        this.digitalSignatureServiceStore.manageSignature(
          operation,
          true,
          this.detectDeviceService.isAccessByDevice(),
          false,
          printContract.bindOffer
        );
      }
    }
  }

  onClickPendingINE(element: Operation): void {
    this.keepSearch.emit(element);

    let url = this.router.url.split(';'); //we need to remove the params
    localStorage.setItem('pageOpenSignature', JSON.stringify({ url: url[0] }));

    let ineDTO: IneDTOcall;
    ineDTO = this.requestPanelStore.validateINE(element, this.userInfo);
    console.log(ineDTO);
    this.ineSignaturaStore.setRequestIneSelected(ineDTO);
    this.router.navigate(['/requests/pending-ine/']);
  }

  onClickVideoselfing(element: Operation): void {
    let videoSelfingDTO = this.requestPanelStore.validateVideoSelfing(element, this.userInfo);
    this.getDataStore.setOperationVideoselfing(videoSelfingDTO);
    this.router.navigate([URL_REQUESTS_PENDING_VIDEOSELFING]);
  }

  onClickPaymentSheet(element: Operation): void {
    this.activityStore.getPdfPaymentReport(element?.numOperation, this.translateService.currentLang).then(
      (result) => {
        if (result) {
          let file = new Blob([result], { type: 'application/pdf' });
          FileSaver.saveAs(file, 'HojaDePago_' + this.datePipe.transform(Date.now(), 'ddMMyyyy') + '.pdf');
        }
      },
      (error) => console.error(error)
    );
  }

  onClickNextPage(): void {
    if (this.isMainPanel) {
      this.requestSubscription?.unsubscribe();
      this.requestPanelStore
        .loadOperationsPagination(this.state.id, this.paginationKeys, this.numPage.toString(), 'N')
        .then(
          (data) => {
            this.dataSource.data = data.detailsOperations.operations;
            this.numPage = parseInt(data.numPage);
            this.paginationKeys = data.paginationKeys;
            this.hasPreviousKey = this.numPage > 0;
            if (data.detailsOperations.nextKey === '') {
              this.hasNextKey = false;
            }
          },
          (error) => console.error(error)
        );
    } else {
      this.loadMoreOperations('N');
    }
  }

  onClickPreviousPage(): void {
    if (this.isMainPanel) {
      this.requestSubscription?.unsubscribe();
      this.requestPanelStore
        .loadOperationsPagination(this.state.id, this.paginationKeys, this.numPage.toString(), 'P')
        .then(
          (data) => {
            this.dataSource.data = data.detailsOperations.operations;
            this.numPage = parseInt(data.numPage);
            this.paginationKeys = data.paginationKeys;
            this.hasPreviousKey = this.numPage > 0;
            if (data.detailsOperations.nextKey === '') {
              this.hasNextKey = false;
            } else {
              this.hasNextKey = true;
            }
          },
          (error) => console.error(error)
        );
    } else {
      this.loadMoreOperations('P');
    }
  }

  onClickCancelRequest(element: Operation) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';

    dialogConfig.data = {
      text: '¿Desea anular esta solicitud?',
      icon: 'icon-ic_warning',
      buttonCancel: true,
      noRedirect: true,
    };
    const dialogNotary = this.dialog.open(ResponseDialogComponent, dialogConfig);
    dialogNotary.afterClosed().subscribe((data) => {
      if (data) {
        this.requestPanelStore.cancelResquest(element).then(
          (data) => {
            dialogConfig.data = {
              text: 'La solicitud se ha anulado correctamente',
              icon: 'icon-ic_circle_check',
              buttonCancel: false,
              noRedirect: true,
            };
            this.dialog.open(ResponseDialogComponent, dialogConfig);
          },
          (error) => {
            dialogConfig.data = {
              text: 'Error al anular la solicitud',
              icon: 'icon-ic_circle_cross',
              buttonCancel: false,
              noRedirect: true,
            };
            this.dialog.open(ResponseDialogComponent, dialogConfig);
            console.error(error);
          }
        );
      }
    });
  }

  /* METHODS TO CHECK FOR ATTRIBUTIONS*/

  hasViewAttribution(): boolean {
    return (
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_VIEW_OPERATION) ||
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_VIEW_REDUCED_CAPTAIN) ||
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_VIEW_CAPTAIN_NO_BUY_MG) ||
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_VIEW_CAPTAIN_BUY_MG) ||
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ALTA_BP)
    );
  }

  hasAttachAttribution(element: Operation): boolean {
    let hideStatusPendingFormalized =
      element.hostStatus !== null && element.hostStatus !== REQUEST_CONDTIONATED_VALIDATION;

    return (
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ATTACH_DOCUMENTATION) &&
      !this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ALTA_BP) &&
      hideStatusPendingFormalized
    );
  }

  hasPrintingOrSigningAttribution(): boolean {
    return this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_PRINT_CONTRACTS);
  }

  hasPrintingVideoSelfing(element: Operation): boolean {
    if (element.digitalId === 'S' || element.digitalId === 'C') {
      if (
        this.credentials.credentials.userType === UserType.ADMIN ||
        element.status === FORMALIZADAS_ABONADAS_VALIDADAS
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  hasPrintingNotary(): boolean {
    return this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_PRINT_OPERATION_SIGN_NOTARY);
  }

  isEnabledINE(element: Operation): boolean {
    return (
      element.operative !== OPERATIVE_EIC &&
      !element.ine &&
      (this.state.id === REQUEST_APPROVED ||
        this.state.id === REQUEST_PENDING_PAYMENT_INCIDENT ||
        this.state.id === REQUEST_STUDYING ||
        this.state.id === REQUEST_CONDTIONATED_VALIDATION)
    );
  }

  isEnabledVideoselfing(element: Operation) {
    return (
      element.digitalId === 'S' &&
      (element.status === 'PA' || element.status === '15' || element.status === 'PE') &&
      element.ine
    );
  }

  isEnabledviewRequest(element: Operation) {
    return element.visibility === VALUE_TRUE;
  }

  isEnabledCancel(element: Operation) {
    return (
      element.operative !== OPERATIVE_EIC &&
      element.status !== '95' &&
      element.status !== '90' &&
      element.status !== 'DN'
    );
  }

  isEnabledDigitalSignature(element: Operation): boolean {
    return (
      element.operative !== OPERATIVE_EIC &&
      this.hasPrintingOrSigningAttribution() &&
      element.print &&
      (((element.printCode === '1' ||
        element.printCode === '7' ||
        element.printCode === '5' ||
        element.printCode === 'R') &&
        this.userInfo.typeUser !== 'M') ||
        element.printCode === '2' ||
        element.printCode === '4' ||
        element.printCode === '6') &&
      (element.digitalSignatureFlag !== 'S' ||
        (element.digitalSignatureFlag === 'S' &&
          this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_PRINT_OPERATION_SIGN_NOTARY))) &&
      (element.digitalSignature === 'P' || element.digitalSignature === 'R') &&
      element.sendSync
    );
  }

  isEnabledPrinting(element: Operation): boolean {
    return (
      element.operative !== OPERATIVE_EIC &&
      ((element.status == FORMALIZADAS_ABONADAS_VALIDADAS && element.operative === 'MNG') ||
        element.operative !== 'MNG') &&
      this.hasPrintingOrSigningAttribution() &&
      element.ine &&
      element.print &&
      (element.printCode === '3' ||
        element.printCode === '1' ||
        element.printCode === '7' ||
        element.printCode === '5' ||
        (element.printCode === 'R' && this.userInfo.typeUser !== 'M') ||
        element.printCode === '2' ||
        element.printCode === '4' ||
        element.printCode === '6')
      // && (element.digitalSignatureFlag !== 'S' || element.digitalSignatureFlag === 'S')) ||
      // (((element.printCode === '1' && this.userInfo.typeUser !== 'M') || element.printCode === '4') && element.digitalSignatureFlag === 'S' && this.hasPrintingNotary()) ||
      // (element.printCode === '2' && element.digitalSignatureFlag === 'S' && this.hasPrintingNotary())
    );
  }

  isEnabledForwarding(element: Operation): boolean {
    //TODO: condición para mostrar el sobre, tendría que ser sendAsync sea true y q en digitalsignature llegue R si es sin email, pero host está enviando sendAsync true
    //si supera el máximo de intervinientes, se ha de revisar en https://jira.worldline.com/browse/ESPSCFWMTS-3317, de momento dejamos las condiciones como está en la actual
    //en la actual si supera el máximo de intervinientes aunq sea async se muestra el lápiz porque no podemos utilizar el parámetro sendasync, pero el de firma digital sí lo tenemos

    return (
      element.operative !== OPERATIVE_EIC &&
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_FORWARD_MAIL_ACQUIESECENCE_SIGN) &&
      (this.state.id === 'PA' || this.state.id === '15') &&
      (element.digitalSignature === 'P' || element.noMobile) &&
      element.sendAsync &&
      element.print &&
      element.digitalId != 'S' &&
      element.ine &&
      element.printCode != '0'
    );
  }

  isEnabledPaymentSheets(element: Operation): boolean {
    return (
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_PAYMENT_SHEET) &&
      element.numCon !== null &&
      element.finacialProduct !== '15' &&
      (this.state.id === 'PV' || this.state.id === '90')
    );
  }

  isOperativeEIC(element: Operation): boolean {
    return element.operative === OPERATIVE_EIC;
  }

  isEnabledForwardLink(element: Operation): boolean {
    return (
      element.operative === 'EIC' &&
      element.digitalId != 'S' &&
      (element.status === 'PA' || element.status === 'PF' || element.status === '00')
    );
  }

  onClickForwardLink(element: Operation) {
    //abrir popup, dar a elegir si es por telefono o por email y llamar al servicio
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';
    dialogConfig.data = { operation: element, phone: element.noMobile, email: element.noEmail };
    this.dialog.open(ForwardLinkComponent, dialogConfig);
  }

  /* VALIDATION */
  hasAnyOperation(): boolean {
    return this.dataSource.data?.length > 0;
  }

  createPdf() {
    let doc = new jsPDF();
    let dataPdf: any[] = [];

    const date = moment().locale('es');
    const filename = this.translateService.instant('last.operations') + date.format('DDMMYYYY');

    doc.setProperties({
      title: 'Últimas operaciones',
    });
    doc.text('Listado de las últimas operaciones', 14, 45);
    doc.setFontSize(12);
    doc.text(this.translateService.instant(this.title), 14, 52);
    var img = new Image();
    img.src = 'assets/img/logo.PNG';
    doc.addImage(img, 'png', 3, 10, 80, 30);

    this.dataSource.data.forEach((item) => {
      dataPdf.push({
        numOperation: item?.numOperation,
        dateEntry: item?.dateEntry,
        dateStatus: item?.dateStatus,
        nameHolder: item?.nameHolder,
        nameVendor: item?.nameVendor,
        prod: item?.prod,
        prot: item?.prot,
        financed: item?.financed,
      });
    });

    autoTable(doc, {
      startY: 55,
      head: [this.head.map((header) => this.translateService.instant(header))],
      headStyles: { fillColor: '#969696' },
      showHead: 'firstPage',
      body: dataPdf.map(Object.values),
    });

    var blob = doc.output('blob');
    FileSaver.saveAs(blob, filename);
    window.open(URL.createObjectURL(blob));
  }

  createExcel(event?: Event) {
    event.stopPropagation();
    let dataForExcel: any[] = [];
    const date = moment().locale('es');
    const filename = this.translateService.instant('last.operations') + date.format('DDMMYYYY');

    this.dataSource.data.forEach((row: Operation) => {
      if (row.dateStatus === null) {
        row.dateStatus = '';
      } else if (!row.dateStatus) {
        row.dateStatus = '';
      }
      const {
        digitalSignature,
        digitalSignatureFlag,
        ine,
        numCon,
        print,
        printCode,
        finacialProduct,
        sendAsync,
        ...data
      } = row;
      const dataExcelOrder = JSON.stringify(data, [
        'numOperation',
        'dateEntry',
        'dateStatus',
        'nameHolder',
        'nameVendor',
        'prod',
        'prot',
        'financed',
      ]);
      const ObjectDataExcel = JSON.parse(dataExcelOrder);
      dataForExcel.push(Object.values(ObjectDataExcel));
    });

    const excelData = {
      fileName: filename,
      state: this.state.value,
      headers: this.head.map((header) => this.translateService.instant(header)),
      data: dataForExcel,
    };
    this.excelService.exportExcel(excelData, this.translateService.instant('request.excel.name'));
  }

  onMenuOpen(event: any) {
    this.selectedRow = event;
  }

  onMenuClose() {
    this.selectedRow = undefined;
  }

  checkNameColorStatus(element: Operation): { name: string; class: string; url: string } {
    if (element.hostStatus === HostCodes.PENDING_SCORING) {
      return {
        name: this.translateService.instant('chips.completeData'),
        class: 'completeData',
        url: 'onClickViewRequest(element)',
      };
    } else if (
      element.hostStatus === HostCodes.DENIED ||
      element.hostStatus === HostCodes.PENDING_CONTRACT ||
      element.hostStatus === HostCodes.NOT_VALIDATED ||
      element.hostStatus === HostCodes.SIGNED ||
      element.hostStatus === HostCodes.PENDING_SIGNED_CONTRACT ||
      element.hostStatus === HostCodes.PENDING_COTITULAR_JUSTIFICANTS ||
      element.hostStatus === HostCodes.PAID_PENDING_COMPRAS_JUSTIFICANTS ||
      element.hostStatus === HostCodes.DATA_STUDY_PENDING ||
      element.hostStatus === HostCodes.OPERATION_CANCELED ||
      element.hostStatus === HostCodes.AUTOMATIC_DENIAL ||
      element.hostStatus === HostCodes.OPERATION_CANCELED_2 ||
      element.hostStatus === HostCodes.FRAUD_OK
    ) {
      return { name: this.translateService.instant('chips.noChip'), class: 'no-status', url: '' };
    } else if (
      element.hostStatus === HostCodes.PAID_PENDING_SIGNED_CONTRACT ||
      element.hostStatus === HostCodes.APPROVED_PENDING_ANTI_FRAUD ||
      element.hostStatus === HostCodes.PAID_PENDING_TITULAR_JUSTIFICANTS ||
      element.hostStatus === HostCodes.PAID_PENDING_COTITULAR_JUSTIFICANTS ||
      element.hostStatus === HostCodes.PAID_PENDING_ADEQUATE_JUSTIFICANTS ||
      element.hostStatus === HostCodes.PAID_PENDING_ANTI_FRAUD_REFERENCES ||
      element.hostStatus === HostCodes.PAID_PENDING_VARIOUS_TITULAR_JUSTIFICANTS ||
      element.hostStatus === HostCodes.PAID_PENDING_JUSTIFICANTS_AND_REFERENCES ||
      element.hostStatus === HostCodes.PAID_CONTRACT_DOCUMENTATION_WITH_INCIDENTS ||
      element.hostStatus === HostCodes.FORMALIZED
    ) {
      return { name: this.translateService.instant('chips.noChip'), class: 'no-status', url: '' };
    } else if (
      element.hostStatus === HostCodes.PENDING_TITULAR_JUSTIFICANTS ||
      element.hostStatus === HostCodes.APPROVED_PENDING_JUSTIFICANTS_AND_REFERENCES ||
      element.hostStatus === HostCodes.GUARANTEES_STUDY_PENDING ||
      element.hostStatus === HostCodes.REGISTRIES_STUDY_PENDING
    ) {
      return {
        name: this.translateService.instant('chips.documentationPending'),
        class: 'documentationPending',
        url: 'onClickAttach(element)',
      };
    } else if (
      element.hostStatus === HostCodes.DOC_OK_PENDING_SIGNATURE ||
      element.hostStatus === HostCodes.PENDING_GOOD_DELIVERY
    ) {
      return {
        name: this.translateService.instant('chips.validatedSignatureIne'),
        class: 'validatedSignatureIne',
        url: '',
      };
    } else if (
      element.hostStatus === HostCodes.AVALISTA_STUDY_PENDING ||
      element.hostStatus === HostCodes.REFERENCES_STUDY_PENDING
    ) {
      return {
        name: this.translateService.instant('chips.addParticipant'),
        class: 'addParticipant',
        url: 'onClickViewRequest(element,true)',
      };
    } else if (
      element.hostStatus === HostCodes.IN_COMPLIANCE_STUDY ||
      element.hostStatus === HostCodes.PENDING_STUDY ||
      element.hostStatus === HostCodes.OPERATION_ASSIGNED_BY_RISKS ||
      element.hostStatus === HostCodes.MANUAL_DOUT
    ) {
      return { name: this.translateService.instant('chips.review'), class: 'review', url: '' };
    } else {
      return { name: 'no-status', class: 'no-status', url: '' };
    }
  }
}
